// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ReceiptsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/receipts
 * Lists payment receipts for a payroll execution
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_ReceiptsResponseDados = number[];

export type Payroll_ReceiptsResponse = ApiResponse<Payroll_ReceiptsResponseDados>;

registerResponseContract('Payroll_ReceiptsResponse', {})
